import { Button, Divider, IconButton, Typography } from "@suraasa/placebo-ui"
import {
  AssessmentQuestion,
  QuestionStatus,
} from "api/resources/assessments/types"
import clsx from "clsx"
import { getQuestionStatus } from "features/Assessments/helpers"
import { Xmark } from "iconoir-react"

import Legend from "./Legend"

const QuestionPanel = ({
  onClose,
  onQuestionChange,
  currentQuestion,
  questions,
}: {
  onClose?: () => void
  onQuestionChange: (questionNumber: number) => void
  currentQuestion: AssessmentQuestion
  questions: AssessmentQuestion[]
}) => {
  const getActiveBtnColor = (
    question: AssessmentQuestion,
    status: QuestionStatus
  ) => {
    if (currentQuestion.questionNumber !== question.questionNumber) return
    switch (status) {
      case QuestionStatus.ANSWERED:
        return `hover:bg-success-700 outline-2 outline-interactive-400 outline-offset-1`
      case QuestionStatus.MARKED_FOR_REVIEW:
        return `hover:bg-warning-700 outline-2 outline-interactive-400 outline-offset-1`
      default:
        return ""
    }
  }

  return (
    <div className="relative z-3 h-full lg:rounded-lg lg:bg-common-white-500 lg:py-2 lg:shadow-[0px_6px_15px_rgba(0,0,0,0.05)]">
      <div className="grid grid-flow-col items-center justify-between px-2 pt-2 lg:pl-2 lg:pt-0">
        <Legend
          list={[
            {
              title: "Not Answered",
              backgroundColor: "bg-secondary-50",
              borderColor: "border border-onSurface-500",
            },
            {
              title: "Answered",
              backgroundColor: "bg-success-500",
              borderColor: "border border-success-500",
            },
            {
              title: "Marked for review",
              backgroundColor: "bg-warning-500",
              borderColor: "border border-warning-500",
            },
          ]}
        />
        <IconButton className="text-common-black-200 lg:hidden">
          <Xmark onClick={onClose} />
        </IconButton>
      </div>
      <Divider weight="light" className="my-2" />

      <Typography
        variant="preTitle"
        className="px-2 text-onSurface-600 md:max-lg:flex-none lg:pl-2"
      >
        Questions
      </Typography>
      <div className="my-2 grid grid-cols-5 gap-y-2 px-2 py-0.5 sm:grid-cols-10 lg:grid-cols-4 lg:px-2">
        {questions.map(ques => {
          const status = getQuestionStatus(ques)
          const activeClass = getActiveBtnColor(ques, status)

          return (
            <Button
              onClick={() => onQuestionChange(ques.questionNumber)}
              key={ques.id}
              size="sm"
              className={clsx(
                "size-6 rounded-lg border-2 border-secondary-500 bg-secondary-50 text-common-black-700 hover:bg-secondary-200 active:bg-secondary-200 ",
                activeClass,
                "flex justify-center p-1",
                {
                  "text-common-white-500 bg-warning-500 border-2 border-warning-500 hover:bg-warning-600 active:bg-warning-400":
                    status === QuestionStatus.MARKED_FOR_REVIEW,
                  "text-common-white-500 border-2 border-success-500 bg-success-500 hover:bg-success-600 active:bg-success-400":
                    status === QuestionStatus.ANSWERED,
                }
              )}
            >
              <Typography variant="strong">{ques.questionNumber}</Typography>
            </Button>
          )
        })}
      </div>
    </div>
  )
}

export default QuestionPanel
